import './css/main.css'
import "@vueform/multiselect/themes/default.css";
import 'bootstrap';
import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import icons from '@/configs/icons.config'
import components from '@/configs/components.config'
import 'sweetalert2/dist/sweetalert2.min.css'
import '@fontsource-variable/inter';
import '@fontsource-variable/montserrat';
import { createApp } from 'vue'
import { createPinia } from "pinia";
import App from './App.vue'
import router from './router'
import VueApexCharts from "vue3-apexcharts";
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

const app = createApp(App)
icons();
components(app);
app.component('VueDatePicker', VueDatePicker);
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(VueApexCharts)
app.use(router)
app.use(createPinia())
window.$ = $
app.mount('#app')
